import { useTheme } from '@material-ui/core/styles'
import React from 'react'

import { Theme } from '../../lib/theming/Theme'
import ReleaseCard, { ReleaseCardProps } from './ReleaseCard'

const SoldOutReleaseCard = (releaseCardProps: ReleaseCardProps) => {
  const { palette } = useTheme<Theme>()
  return (
    <ReleaseCard
      {...releaseCardProps}
      styles={{
        cardBackgroundColor: palette.grey[200],
        titleHeadingColor: palette.grey[500],
        titleTextColor: palette.grey[800],
      }}
      variant="soldOut"
    />
  )
}
export default SoldOutReleaseCard
